import { atomFamily, useRecoilState } from "recoil";

interface TableState {
    searchBarText: string;
    tablePage: number;
    resetSearchTrigger: boolean;
}

export const tableStateFamily = atomFamily<TableState, string>({
    key: "tableState",
    default: {
        searchBarText: "",
        tablePage: 0,
        resetSearchTrigger: false,
    },
});

const useTableState = (tableId: string) => {
    const [state, setState] = useRecoilState(tableStateFamily(tableId));

    const setSearchBarText = (searchBarText: string) => {
        setState((current) => ({
            ...current,
            searchBarText,
        }));
    };

    const setTablePage = (tablePage: number) => {
        setState((current) => ({
            ...current,
            tablePage,
        }));
    };

    const setResetSearchTrigger = () => {
        setState((current) => ({
            ...current,
            resetSearchTrigger: !current.resetSearchTrigger,
        }));
    };

    return {
        searchBarText: state.searchBarText,
        tablePage: state.tablePage,
        resetStateTrigger: state.resetSearchTrigger,
        setSearchBarText,
        setTablePage,
        setResetSearchTrigger,
    };
};

export default useTableState;
